import * as React from 'react';

export const LazyConseilGestionKnowledgeAndExperienceQuestionnaire = React.lazy(() => import('./component'));
